import React from 'react'

import StoryCard from './StoryCard'
import StoryCardSettings from './StoryCardSettings'


export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {
      isSelected: this.props.item.isSelected,
      position:this.props.item.position
    }
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      if (this.props.item.isSelected != this.state.isSelected)
      {
        this.state.isSelected = this.props.item.isSelected;
        this.forceUpdate();
      }
    }, 200)
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render()
  {
    var {
      item,
      onSelect,
      onShiftUp,
      onShiftDown,
      onRemove,
      onShiftAlign,
      onShiftOrder,
      index,
    } = this.props;

    var out_title=''
    switch(item.title) {
      case 'Scene':
          out_title='分頁';
        break;
      
      case 'Media':
          out_title='媒體';
        break;
      case 'Text':
      case 'Narrative':
      default:
          out_title='';
    }
console.log(item.name);
    return (
        <StoryCard
            index={this.props.index}            
            item={this.props.item}
            isSelected={this.state.isSelected}
            isAllowEdit={item.type === 'Text' || item.type === 'Media' || item.type === 'Narrative'}
            onShiftUp={() => {
              onShiftUp && onShiftUp(item);
            }}
            onShiftDown={() => {
              onShiftDown && onShiftDown(item);
            }}
            onSelect={() => {
              onSelect && onSelect(item);
              this.forceUpdate();
            }}
            onRemove={() => {
              onRemove && onRemove(item);
              this.forceUpdate();
            }}
            onShiftAlign={() => {
              onShiftAlign && onShiftAlign(item);
              this.forceUpdate();
            }}
            onShiftOrder={() => {
              onShiftOrder && onShiftOrder(item);
              this.forceUpdate();
            }}
            suffixes={(
                <StoryCardSettings
                    {...this.props}
                    onChangeItem={() => {
                      this.forceUpdate();
                    }}
                />
            )}>
          {index} - 

          {item.type === 'Text' || item.type === 'Narrative' ?(
          <select
                value={item.type}
                onChange={(e) => {
                  item.title=e.target.value;
                  item.type = e.target.value;
                  if (item.type=="Text"){
                    item._attributes.style="msg";
                    item._attributes.position="left";
                  }else{
                    item._attributes.style="narrative";
                    item.name.enabled=false;
                    item._attributes.position="center";
                  }
                  this.forceUpdate();
                }}
            >
              <option value={'Text'}>{'對白'}</option>              
              <option value={'Narrative'}>{'旁白'}</option>
             
            </select>
          ):null}

          {out_title} - 

          {item.type === 'Text' && item.name.enabled==true ?(
              item.name._text
          ):null}
          
          <br/>
          {item.type === 'Text' || item.type === 'Narrative' ?(
          <input type={`text`}
            value={this.props.item.text._text}
            onChange={(e) => {
              this.props.item.text._text = e.target.value;
              this.forceUpdate();
            }}/>
          ):null}
        </StoryCard>
    )
  }
}